module.exports = __webpack_public_path__ + "img/sushi-640.e63cbda3.jpg";